import { ROUTING_CONFIG } from '@uplift/constants';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { PublicProviderProfile } from './pages';

export const App: React.VFC = () => (
  <BrowserRouter>
    <Switch>
      <Route path={ROUTING_CONFIG.publicProviderProfile}>
        <PublicProviderProfile />
      </Route>
      <Route path="*">
        <Redirect to="https://joinuplift.co" />
      </Route>
    </Switch>
  </BrowserRouter>
);
